import { render, staticRenderFns } from "./PeopleForm.vue?vue&type=template&id=2b8f036a"
import script from "./PeopleForm.vue?vue&type=script&lang=js"
export * from "./PeopleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports